module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5Aonk"))).then(() => parcelRequire('l8tnS'));